import React from "react";

import { Button } from "../Button";
import { Divider } from "../Divider";

import styles from "./Drawer.scss";

export interface DrawerFooterProps {
  /**
   * Function to call when the primary button is clicked
   */
  onPrimary?: () => void;
  /**
   * Text to display on the primary button
   */
  primaryText?: string;
  /**
   * Function to call when the secondary button is clicked
   */
  onSecondary?: () => void;
  /**
   * Text to display on the secondary button
   */
  secondaryText?: string;
  /**
   * Function to call when the tertiary button is clicked
   */
  onTertiary?: () => void;
  /**
   * Text to display on the tertiary button
   */
  tertiaryText?: string;
}

/**
 * The footer for the drawer. Abstracted to another component to ease testing.
 */
export function DrawerFooter({
  onPrimary,
  primaryText = "Save",
  onSecondary,
  secondaryText = "Close",
  onTertiary,
  tertiaryText = "",
}: DrawerFooterProps) {
  if (!onPrimary && !onSecondary && !onTertiary) {
    return null;
  }

  return (
    <div
      className={styles.drawerFooterContainer}
      data-testid="drawer-footer-container"
    >
      <Divider />
      <div className={styles.drawerFooterWrapper}>
        {Boolean(onPrimary) && (
          <div className={styles.drawerFooterAction}>
            <Button
              variant="primary"
              onClick={onPrimary}
              data-testid="drawer-footer-primary-button"
            >
              {primaryText}
            </Button>
          </div>
        )}
        {Boolean(onSecondary) && (
          <div className={styles.drawerFooterAction}>
            <Button
              variant="secondary"
              onClick={onSecondary}
              data-testid="drawer-footer-secondary-button"
            >
              {secondaryText}
            </Button>
          </div>
        )}
        {Boolean(onTertiary) && (
          <div className={styles.drawerFooterAction}>
            <Button
              variant="system"
              onClick={onTertiary}
              data-testid="drawer-footer-tertiary-button"
            >
              {tertiaryText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
